import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../utils/axiosConfig'; //新增CSRF設定
import { useTranslation } from 'react-i18next';
import Step1 from './ReportSteps/Step1';
import Step2 from './ReportSteps/Step2';
import Step3 from './ReportSteps/Step3';
import Step4 from './ReportSteps/Step4';
import StepIndicator from './ReportSteps/StepIndicator';
import API_URL from '../config';
import { toast } from "react-toastify";

function Report() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
 
  // 將所有步驟需要的資料放在 formData 中
  const [formData, setFormData] = useState({
    incidentType: '',
    description: '',
    evidenceFiles: [null], // 初始為一個空的檔案
    email: '',
    otherIncidentType: '',
    fullName: '',
    phoneNumber: '',
    country: '',
    city: '',
    // 將步驟2的所有資料放入 formData 內
    scammerAddresses: [
      {
        victimWalletAddress: '',
        scammerWalletAddress: '',
        chain: '',
        date: '',
        amount: '',
        currency: '',
        transactionID: '',
        transactionScreenshots: [],
      },
    ],
    websites: [{ url: '' }],
    tokenIDs: [{ tokenID: '' }],
    ipAddresses: [{ ip: '' }],
    contacts: [{ contact: '' }],
  });

  // 更新資料變更函數
  const handleChange = (input) => (e) => {
    const value = e && e.target ? e.target.value : e;
    setFormData((prevData) => ({ ...prevData, [input]: value }));
  };

  // 下一步
  const nextStep = () => {
    setCurrentStep((prev) => prev + 1);
    window.scrollTo(0, 0);
  };

  // 上一步
  const prevStep = () => {
    setCurrentStep((prev) => prev - 1);
    window.scrollTo(0, 0);
  };

  // 提交表單
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataToSend = new FormData();
  
    // 處理其他資料
    Object.keys(formData).forEach((key) => {
      if (key === 'evidenceFiles') {
        // 上傳證據檔案
        formData.evidenceFiles.forEach((file) => {
          if (file) {
            formDataToSend.append('evidenceFiles', file);
          }
        });
      } else if (key === 'scammerAddresses') {
        // 上傳交易截圖
        formData.scammerAddresses.forEach((address, index) => {
          if (address.transactionScreenshots && address.transactionScreenshots[0]) {
            formDataToSend.append(`transactionScreenshots[${index}]`, address.transactionScreenshots[0]);
          }
        });
        const scammerAddressesWithoutFiles = formData.scammerAddresses.map(
          ({ transactionScreenshots, ...rest }) => rest
        );
        formDataToSend.append('scammerAddresses', JSON.stringify(scammerAddressesWithoutFiles));
      } else if (['incidentType', 'email', 'otherIncidentType', 'fullName', 'phoneNumber', 'country', 'city'].includes(key)) {
        // 這些純字串欄位不需要 JSON.stringify
        formDataToSend.append(key, formData[key]);
      } else {
        // 其他欄位（例如陣列或物件）需要進行 JSON.stringify
        formDataToSend.append(key, JSON.stringify(formData[key]));
      }
    });
  
    try {
      const response = await axios.post(`${API_URL}/api/report`, formDataToSend, {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true, // 發送 cookie 確認用戶狀態
      });
  
      if (response.data.guestId) {
        localStorage.setItem('guestId', response.data.guestId);
        toast.success(`${t('reportSubmitted')} - ${t('guestIdNote')}: ${response.data.guestId}`);
      } else {
        toast.success(t('reportSubmitted'));
      }
  
      navigate('/');
    } catch (error) {
      console.error('Error submitting report:', error);
    }
  };
  



  const steps = [
    <Step1
      nextStep={nextStep}
      handleChange={handleChange}
      values={formData}
      setFormData={setFormData}
    />,
    <Step2
      nextStep={nextStep}
      prevStep={prevStep}
      handleChange={handleChange}
      values={formData}
      setFormData={setFormData}
    />,
    <Step3
      nextStep={nextStep}
      prevStep={prevStep}
      handleChange={handleChange}
      values={formData}
      setFormData={setFormData}
    />,
    <Step4
      prevStep={prevStep}
      handleSubmit={handleSubmit}
      values={formData}
      handleChange={handleChange}
      setFormData={setFormData}
    />,
  ];

  return (
    <div className="bg-gray-100 dark:bg-gray-900 min-h-screen">
      <div
        className="w-full h-64 bg-cover bg-center flex items-center justify-center text-white text-3xl font-bold"
        style={{ backgroundImage: `url('/images/myReportsBanner.png')` }}
      >
        {t("generateReport")}
      </div>
    <div className="container mx-auto py-8">

      <StepIndicator currentStep={currentStep} />
      <form onSubmit={handleSubmit}>{steps[currentStep - 1]}</form>
    </div>
    </div>
  );
}

export default Report;
